/**
 * @flow
 * @relayHash b2ac1fd9138cb137f855571d9f1364a8
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type StockOrderList_viewer$ref = any;
export type StockOrderListQueryVariables = {|
  first?: ?number,
  offset?: ?number,
  search?: ?string,
  side?: ?string,
  statusIn?: ?$ReadOnlyArray<?string>,
  exchange?: ?string,
  accountId?: ?string,
  contractId?: ?string,
  orderType?: ?string,
  algo?: ?string,
  aot?: ?string,
  instrumentTypeIn?: ?$ReadOnlyArray<?string>,
  brokerOrderId?: ?number,
|};
export type StockOrderListQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: StockOrderList_viewer$ref
  |}
|};
export type StockOrderListQuery = {|
  variables: StockOrderListQueryVariables,
  response: StockOrderListQueryResponse,
|};
*/


/*
query StockOrderListQuery(
  $first: Int
  $offset: Int
  $search: String
  $side: String
  $statusIn: [String]
  $exchange: String
  $accountId: ID
  $contractId: ID
  $orderType: String
  $algo: String
  $aot: String
  $instrumentTypeIn: [String]
  $brokerOrderId: Float
) {
  viewer {
    ...StockOrderList_viewer_4ft4cB
    id
  }
}

fragment StockOrderList_viewer_4ft4cB on Query {
  stockOrders(first: $first, offset: $offset, side: $side, search: $search, statusIn: $statusIn, exchange: $exchange, accountId: $accountId, contractId: $contractId, orderType: $orderType, algo: $algo, advancedOrderType: $aot, instrumentTypeIn: $instrumentTypeIn, brokerOrderId: $brokerOrderId, orderBy: "-createdAt") {
    edges {
      node {
        orderPtr {
          orderapprovalcontractSet {
            edges {
              node {
                id
                orderStatus
              }
            }
          }
          id
        }
        id
        orderType
        side
        updatedAt
        createdAt
        quantityToDate
        executedQuantityToDate
        matched
        quantity
        cashQuantity
        blockedBaseCharges
        blockedHoldings
        blockedLocalCharges
        blockedProceeds
        advancedOrderType
        portfolioOrder {
          id
          portfolio {
            trackingVue {
              name
              id
            }
            id
          }
        }
        contract {
          symbol
          currency
          id
          exchange {
            symbol
            id
          }
        }
        account {
          id
          name
          clientaccount {
            id
            accountType
          }
        }
        status
        brokerOrder {
          id
          matched
          quantity
          quantityFilled
          quantityLeft
          side
        }
        tradeInvoice {
          id
          pdfUrl
          pdf
          state
          createdAt
          updatedAt
          portfolioOrder {
            id
          }
        }
      }
    }
    count
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "side",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "statusIn",
    "type": "[String]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "exchange",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "accountId",
    "type": "ID",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "contractId",
    "type": "ID",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "orderType",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "algo",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "aot",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "instrumentTypeIn",
    "type": "[String]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "brokerOrderId",
    "type": "Float",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "accountId",
  "variableName": "accountId"
},
v2 = {
  "kind": "Variable",
  "name": "algo",
  "variableName": "algo"
},
v3 = {
  "kind": "Variable",
  "name": "brokerOrderId",
  "variableName": "brokerOrderId"
},
v4 = {
  "kind": "Variable",
  "name": "contractId",
  "variableName": "contractId"
},
v5 = {
  "kind": "Variable",
  "name": "exchange",
  "variableName": "exchange"
},
v6 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v7 = {
  "kind": "Variable",
  "name": "instrumentTypeIn",
  "variableName": "instrumentTypeIn"
},
v8 = {
  "kind": "Variable",
  "name": "offset",
  "variableName": "offset"
},
v9 = {
  "kind": "Variable",
  "name": "orderType",
  "variableName": "orderType"
},
v10 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v11 = {
  "kind": "Variable",
  "name": "side",
  "variableName": "side"
},
v12 = {
  "kind": "Variable",
  "name": "statusIn",
  "variableName": "statusIn"
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "side",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "updatedAt",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdAt",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "matched",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "symbol",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "StockOrderListQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "StockOrderList_viewer",
            "args": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "kind": "Variable",
                "name": "aot",
                "variableName": "aot"
              },
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "StockOrderListQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "stockOrders",
            "storageKey": null,
            "args": [
              (v1/*: any*/),
              {
                "kind": "Variable",
                "name": "advancedOrderType",
                "variableName": "aot"
              },
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": "-createdAt"
              },
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/)
            ],
            "concreteType": "StockOrderNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "StockOrderNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "StockOrderNode",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "orderPtr",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "OrderNode",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "orderapprovalcontractSet",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "OrderApprovalContractNodeConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "OrderApprovalContractNodeEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "OrderApprovalContractNode",
                                    "plural": false,
                                    "selections": [
                                      (v13/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "orderStatus",
                                        "args": null,
                                        "storageKey": null
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v13/*: any*/)
                        ]
                      },
                      (v13/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "orderType",
                        "args": null,
                        "storageKey": null
                      },
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "quantityToDate",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "executedQuantityToDate",
                        "args": null,
                        "storageKey": null
                      },
                      (v17/*: any*/),
                      (v18/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "cashQuantity",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "blockedBaseCharges",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "blockedHoldings",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "blockedLocalCharges",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "blockedProceeds",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "advancedOrderType",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "portfolioOrder",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PortfolioOrderNode",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "portfolio",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PortfolioNode",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "trackingVue",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "VueNode",
                                "plural": false,
                                "selections": [
                                  (v19/*: any*/),
                                  (v13/*: any*/)
                                ]
                              },
                              (v13/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "contract",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ContractNode",
                        "plural": false,
                        "selections": [
                          (v20/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "currency",
                            "args": null,
                            "storageKey": null
                          },
                          (v13/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "exchange",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ExchangeNode",
                            "plural": false,
                            "selections": [
                              (v20/*: any*/),
                              (v13/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "account",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AccountNode",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v19/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "clientaccount",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ClientAccountNode",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "accountType",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "status",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "brokerOrder",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BrokerOrderNode",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "quantityFilled",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "quantityLeft",
                            "args": null,
                            "storageKey": null
                          },
                          (v14/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tradeInvoice",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeInvoiceNode",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "pdfUrl",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "pdf",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "state",
                            "args": null,
                            "storageKey": null
                          },
                          (v16/*: any*/),
                          (v15/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "portfolioOrder",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PortfolioOrderNode",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "count",
                "args": null,
                "storageKey": null
              }
            ]
          },
          (v13/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "StockOrderListQuery",
    "id": null,
    "text": "query StockOrderListQuery(\n  $first: Int\n  $offset: Int\n  $search: String\n  $side: String\n  $statusIn: [String]\n  $exchange: String\n  $accountId: ID\n  $contractId: ID\n  $orderType: String\n  $algo: String\n  $aot: String\n  $instrumentTypeIn: [String]\n  $brokerOrderId: Float\n) {\n  viewer {\n    ...StockOrderList_viewer_4ft4cB\n    id\n  }\n}\n\nfragment StockOrderList_viewer_4ft4cB on Query {\n  stockOrders(first: $first, offset: $offset, side: $side, search: $search, statusIn: $statusIn, exchange: $exchange, accountId: $accountId, contractId: $contractId, orderType: $orderType, algo: $algo, advancedOrderType: $aot, instrumentTypeIn: $instrumentTypeIn, brokerOrderId: $brokerOrderId, orderBy: \"-createdAt\") {\n    edges {\n      node {\n        orderPtr {\n          orderapprovalcontractSet {\n            edges {\n              node {\n                id\n                orderStatus\n              }\n            }\n          }\n          id\n        }\n        id\n        orderType\n        side\n        updatedAt\n        createdAt\n        quantityToDate\n        executedQuantityToDate\n        matched\n        quantity\n        cashQuantity\n        blockedBaseCharges\n        blockedHoldings\n        blockedLocalCharges\n        blockedProceeds\n        advancedOrderType\n        portfolioOrder {\n          id\n          portfolio {\n            trackingVue {\n              name\n              id\n            }\n            id\n          }\n        }\n        contract {\n          symbol\n          currency\n          id\n          exchange {\n            symbol\n            id\n          }\n        }\n        account {\n          id\n          name\n          clientaccount {\n            id\n            accountType\n          }\n        }\n        status\n        brokerOrder {\n          id\n          matched\n          quantity\n          quantityFilled\n          quantityLeft\n          side\n        }\n        tradeInvoice {\n          id\n          pdfUrl\n          pdf\n          state\n          createdAt\n          updatedAt\n          portfolioOrder {\n            id\n          }\n        }\n      }\n    }\n    count\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c49cdb2ff7eba5f3c6a74f4d0e48d8a3';
module.exports = node;
